function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.98 3.08a7 7 0 10-.06 9.9l-.77-.78a5.9 5.9 0 11.05-8.35l.78-.77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.47 1.96L11.1 4.21l2.5.5-.12-2.76z"
})));